import classNames from "classnames";
import { ReactNode, useRef } from "react";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import {
  SKELETON_BASE_COLOR,
  SKELETON_HIGHLIGHT_COLOR,
} from "../../utils/constants";
import { Button } from "../buttons/button";
import { ScrollToTop } from "../scrollToTop";

export const BareLayout = ({
  children,
  title,
  bodyClassName = "",
  loading = false,
  cancelText = "Cancel",
  cancelLoading = false,
  onCancel,
}: {
  children: ReactNode;
  title: string;
  bodyClassName?: string;
  loading?: boolean;
  cancelText?: string;
  cancelLoading?: boolean;
  onCancel?: () => void;
}) => {
  const navigate = useNavigate();

  const pageRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <ScrollToTop ref={pageRef} />
      <div className="flex h-screen max-h-[100dvh] w-full flex-col bg-light-grey-bg">
        <div className="w-full border-b border-grey-100 py-6 md:py-6">
          {loading ? (
            <div className="max-width">
              <Skeleton
                baseColor={SKELETON_BASE_COLOR}
                highlightColor={SKELETON_HIGHLIGHT_COLOR}
                count={1}
                width={"100%"}
                height={40}
                className=""
              />
            </div>
          ) : (
            <div className="max-width flex items-center justify-between gap-4">
              <p className="font-fustat text-lg font-bold capitalize">
                {title}
              </p>

              <Button
                text={cancelText}
                icon="close-icon"
                type="button"
                variation="plain-grey"
                onClick={() => {
                  if (onCancel !== undefined) {
                    onCancel();
                  } else {
                    navigate(-1);
                  }
                }}
                className="!max-w-fit"
                disabled={cancelLoading}
                loading={cancelLoading}
              />
            </div>
          )}
        </div>

        <div
          className={classNames(
            "max-width relative flex flex-1 overflow-y-scroll py-[34px]",
            bodyClassName,
          )}
          ref={pageRef}
        >
          {children}
        </div>
      </div>
    </>
  );
};
